import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Text, FlexContainer } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { pathNameSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { useFlags } from 'Hooks/useFlags';
import { Hamburger } from 'Components/UI';
import { handleUserHeader } from 'Styles/utils/utils';
import { FlagsKey } from 'Types/common';
import { NavItemsIds, userLinks } from './links';
import * as Styled from './styles';

const NavItemById = {
  [NavItemsIds.HELP]: Styled.HelpNavItem,
  [NavItemsIds.ACCOUNT]: Styled.AccountNavItem,
};

const UserNav = (): JSX.Element => {
  const pathname = useSelector(pathNameSelector);
  const { t } = useTranslation(locizeNS.COMMON);
  const { enabled } = useFlags(FlagsKey.MGM_FLOW_ENABLED);
  const isPathActive = useCallback(
    route => route?.split('/')[1] === pathname.split('/')[1],
    [pathname]
  );
  const handleShowMenu = (): void => {
    handleUserHeader();
  };

  return (
    <FlexContainer>
      <Hamburger id="user-hamburger" onClick={handleShowMenu} />
      <Styled.Links id="user-links">
        {userLinks.map(({ id, label, route, action, Icon, condition }) => {
          if ((condition && condition(!enabled)) || !condition) {
            const NavItem = NavItemById[id] ?? Styled.NavItem;
            return (
              <NavItem isActive={isPathActive(route)} onClick={action} key={label}>
                <Icon />
                <Text type="fds_text_semibold_S" tag="span" color="dark_500">
                  {t(label)}
                </Text>
              </NavItem>
            );
          }
          return null;
        })}
      </Styled.Links>
    </FlexContainer>
  );
};

export default UserNav;
